import moment from 'moment'; //Formatting Date
export const formatDate = {
    methods: {
        displayDateTime(date) {
            if (date) {
                return moment(String(date)).format("DD-MMM-YYYY hh:mm a")
            }

        },
        formatDate(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();
            if (d == "Invalid Date") {
                return false
            } else {
                if (month.length < 2) month = "0" + month;
                if (day.length < 2) day = "0" + day;

                return [year, month, day].join("-");
            }
        }
    }
}